import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/free-solid-svg-icons';
export const ToggleButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, onClick, onBlur, onKeyDown, disabled, id, open } = props;
    return /*#__PURE__*/ _jsxs("button", {
        tabIndex: disabled ? -1 : 0,
        ref: ref,
        id: id,
        className: classnames('btn btn-default d-flex dropdown-list__button', {
            disabled: disabled,
            open: open
        }),
        type: "button",
        onClick: onClick,
        onBlur: open ? undefined : onBlur,
        onKeyDown: onKeyDown,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex-grow-1",
                children: children
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ms-2 dropdown-list__toggle",
                children: /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                    icon: faSort
                })
            })
        ]
    });
});
ToggleButton.displayName = 'DropdownListToggle';
